// Bundle size analysis utilities
export const analyzeBundleSize = () => {
  if (process.env.NODE_ENV === 'development') {
    // Log bundle information
    const scripts = document.querySelectorAll('script[src]');
    const styles = document.querySelectorAll('link[rel="stylesheet"]');
    
    console.group('📦 Bundle Analysis');
    console.log(`Scripts loaded: ${scripts.length}`);
    console.log(`Stylesheets loaded: ${styles.length}`);
    
    // Estimate bundle sizes (approximate)
    let totalScriptSize = 0;
    scripts.forEach(script => {
      if (script.src.includes('static/js/')) {
        // Rough estimation based on typical React bundle sizes
        totalScriptSize += 200; // KB estimate
      }
    });
    
    console.log(`Estimated JS bundle size: ~${totalScriptSize}KB`);
    console.groupEnd();
  }
};

// Performance metrics collection
export const collectPerformanceMetrics = () => {
  if ('performance' in window) {
    const navigation = performance.getEntriesByType('navigation')[0];
    const paint = performance.getEntriesByType('paint');
    
    const metrics = {
      domContentLoaded: navigation.domContentLoadedEventEnd - navigation.domContentLoadedEventStart,
      loadComplete: navigation.loadEventEnd - navigation.loadEventStart,
      firstPaint: paint.find(p => p.name === 'first-paint')?.startTime || 0,
      firstContentfulPaint: paint.find(p => p.name === 'first-contentful-paint')?.startTime || 0,
    };
    
    if (process.env.NODE_ENV === 'development') {
      console.table(metrics);
    }
    
    return metrics;
  }
  return null;
};

// Memory usage monitoring
export const monitorMemoryUsage = () => {
  if ('memory' in performance) {
    const memory = performance.memory;
    const metrics = {
      usedJSHeapSize: Math.round(memory.usedJSHeapSize / 1048576), // MB
      totalJSHeapSize: Math.round(memory.totalJSHeapSize / 1048576), // MB
      jsHeapSizeLimit: Math.round(memory.jsHeapSizeLimit / 1048576), // MB
    };
    
    if (process.env.NODE_ENV === 'development') {
      console.log('🧠 Memory Usage:', metrics);
    }
    
    return metrics;
  }
  return null;
};
